import { render, staticRenderFns } from "./TitleMain.vue?vue&type=template&id=58cac321&scoped=true&lang=pug"
import script from "./TitleMain.vue?vue&type=script&lang=ts"
export * from "./TitleMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cac321",
  null
  
)

export default component.exports